import { NOTE, EMAIL } from 'customer-data-objects/engagement/EngagementTypes';

// to be kept in sync with https://git.hubteam.com/HubSpot/CrmPermissions/blob/master/CrmPermissionsLibrary/src/main/java/com/hubspot/crm/permissions/library/EngagementPermissions.java
const GRANULAR_PERMISSIONS_TYPES = [NOTE, EMAIL];
export const useCheckGranularPermissions = engagement => {
  if (!engagement) return false;
  const engagementType = engagement.getIn(['engagement', 'type'], null);
  return !!(engagementType && GRANULAR_PERMISSIONS_TYPES.includes(engagementType));
};